export type ThemeUnit = "rem" | "em";

export type ThemeName = "system" | "light" | "dark" | "legacy";

export type ResolvedThemeName = Exclude<ThemeName, "system">;

export const SUPPORTED_LOCALES = ["en", "fr"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const ANIMATION_LEVELS = [
  "none",
  "reduced",
  "normal",
  "expressive",
] as const;

export type AnimationLevel = (typeof ANIMATION_LEVELS)[number];
